import useSWRMutation from 'swr/mutation';
import { TServiceList } from '@/src/models/produk-kesehatan';
import { consultService } from '../service';

interface IGetServiceListParams {
  offset: number;
  size: number;
  search?: string | null;
  lat: number | undefined;
  long: number | undefined;
  min_price?: number | null;
  max_price?: number | null;
  lokasi?: string[] | null;
  order_by: string | undefined;
  service_method?: string[] | null;
  payment_method?: string[] | null;
  min_date?: string | null;
  max_date?: string | null;
}

export function useGetServiceList() {
  const fetchKey = ['service-list'];

  const { trigger, data, isMutating, error } = useSWRMutation(
    fetchKey,
    async (_, { arg }: { arg: IGetServiceListParams }) => {
      return await consultService.getMarketplaceServiceList(arg);
    },
    {
      throwOnError: true,
    }
  );

  const execute = async (params: IGetServiceListParams) => {
    return await trigger(params);
  };

  return {
    execute,
    data: data as TServiceList | undefined,
    isLoading: isMutating,
    error,
  };
}
